var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.62964,
    y: 2.12085,
    width: 4.375,
    height: 4.375,
    stroke: "#525355",
    strokeWidth: 0.625,
    strokeLinecap: "square"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.14502,
    y: 1.62915,
    width: 4.375,
    height: 4.375,
    transform: "rotate(15 9.14502 1.62915)",
    stroke: "#525355",
    strokeWidth: 0.625,
    strokeLinecap: "square"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.62964,
    y: 8.99585,
    width: 4.375,
    height: 4.375,
    stroke: "#525355",
    strokeWidth: 0.625,
    strokeLinecap: "square"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.50464,
    y: 8.99585,
    width: 4.375,
    height: 4.375,
    stroke: "#525355",
    strokeWidth: 0.625,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.208e7e48cfbd5d0530a7b106091bd3a5.svg";
export { ForwardRef as ReactComponent };